import templateProperty from '../views/subject-property.html';
import templatePop from '../views/studentSubjectSelection.html'
import template_edit from '../views/template_edit.html'
import pdfTemplate from '../views/showpdf.html'

class ManagelistController {
    // @ngInject
    constructor($scope, $rootScope, $state, $mdDialog, localStorageService, 
        authService, CONSTANTS, $sce) {
        'ngInject';
        // $reactive(this).attach($scope);
        let self = this
        $scope.loading = true
        $scope.stateId = 'manageReportCards'
        $scope.filterObj = {}
        $scope.filterObj['school_id'] = localStorageService.get('school_id')
        $scope.pdfData = false
        $rootScope.Title = "Report Card Formats"
        $scope.schoolSelected = undefined
        $scope.dataArry = {}
        $scope.schoolAdmin = undefined
        $scope.FILE_UPLOAD_URL = CONSTANTS.FILE_UPLOAD_URL
        let subsReport = undefined
        $scope.isLoading = false
        self.archived_templates = null
        self.selected_tab = 0
        let _AVAILABLE = "available"
        let _ARCHIVES = 'archives'
        let _SELECTALL_TXT = "Select All"
        let _UNSELECTALL_TXT = "Unselect All"
        $scope.selectedIndex = _AVAILABLE
        $scope.rc_selection = {
            all_selected : false,
            txt : _SELECTALL_TXT,
            selected_any : false
        }
        $scope.pdfClicked = false
        $scope.url = null
        $scope.showPrev = (format) => {
            let isFomArchive = false
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'format', 'parentScope', 'authService', 'localStorageService', 'isFomArchive','$sce', showPdfDialog],
                locals: {
                    "format": format,
                    "parentScope": $scope,
                    authService : authService,
                    localStorageService : localStorageService,
                    isFomArchive : isFomArchive,
                    '$sce' : $sce
                },
                template: pdfTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true
            })
            // $scope.pdfClicked = !$scope.pdfClicked
            // $scope.url = $sce.trustAsResourceUrl('https://oxf4000.educore.guru/uploads/report-formats/type-1-annual.pdf')
        }
        $scope.closepdf = () => {
            $scope.pdfClicked = false;
            $scope.url = null
        }
        
        $scope.selectAllRcs = (rc_selection, isFromArchives) => {
            let all_selected = rc_selection.all_selected
            if(rc_selection.all_selected){
                rc_selection.txt = _UNSELECTALL_TXT
            }else{
                rc_selection.txt = _SELECTALL_TXT
            }
            let formats = self.availableFormats
            if(isFromArchives){
                formats = self.archived_templates
            }
            for (let index = 0; index < formats.length; index++) {
                let element = formats[index];
                element.to_archive = all_selected
            }
            showHideRcSelection(isFromArchives)
        }
        function showHideRcSelection(isFromArchives = false){
            let rc_selection = $scope.rc_selection
            let formats = self.availableFormats
            if(isFromArchives){
                formats = self.archived_templates
            }
            let selected_any = 0
            for (let index = 0; index < formats.length; index++) {
                let element = formats[index];
                if(element.to_archive){
                    selected_any++
                    break;
                }
            }
            rc_selection.selected_any = selected_any ? true : false
        }
        $scope.selectOneRcToArchive = (format, isFromArchives = false) => {
            if(format.to_archive){
                $scope.rc_selection.selected_any = true
            }
            showHideRcSelection(isFromArchives)
        }
        $scope.toggleExpansion = function(accordianData, data, index) {
            _.each(accordianData, function(data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !data.expanded;
            })
        }
        let cb = function(_format, index){
            console.log(_format)
            self.availableFormats[index] = _format
        }
        self.OneRcController = (format, index) => {
            let data = {
                
            }
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'data', 'format', 'parentScope', 'authService', 'localStorageService', 'cb', 
                'index',
                 OneRcController],
                locals: {
                    "data": data,
                    format : format,
                    "parentScope": $scope,
                    authService : authService,
                    localStorageService : localStorageService,
                    cb : cb,
                    index : index
                },
                template: template_edit,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true
            })
        }
        function _breakReference(data) {
            let keys = Object.keys(data)
            let obj = {}
            for (let k = 0; k < keys.length; k++) {
                obj[keys[k]] = data[keys[k]]
            }
            return obj
        }
        function iterateArray(array = []){
            for (let index = 0; index < array.length; index++) {
                let element = array[index];
                element.path = $scope.FILE_UPLOAD_URL + element.path
                let assigned_academics = element.assigned_academics
                let total_classes = 0
                if(assigned_academics){
                    for (let a = 0; a < assigned_academics.length; a++) {
                        let acd = assigned_academics[a];
                        if(acd && acd.classes && acd.classes.length){
                            total_classes = total_classes + acd.classes.length
                        }
                    }
                }
                element['total_classes'] = total_classes
            }
        }
        function callBack(data, isFomArchive){
            if(data){
                if(data.templates){
                    self.availableFormats = data.templates
                    iterateArray(self.availableFormats)
                }
                if(data.archived_templates){
                    self.archived_templates = data.archived_templates
                }
            }
            self.selected_tab = isFomArchive ? 0 : 1
            $scope.$apply()
        }
        $scope.callBack = (data, isFomArchive) => {
            self.availableFormats = []
            self.archived_templates = []
            callBack(data, isFomArchive)
        }
        $scope.confirmToArchive = (isFomArchive = false) => {
            let data = []
            if(isFomArchive){
                data = _.filter(self.archived_templates, function(one){
                    return one.to_archive == true
                })
            }else{
                data = _.filter(self.availableFormats, function(one){
                    return one.to_archive == true
                })
            }
            
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'data', 'parentScope', 'authService', 'localStorageService', 'isFomArchive', ToArchiveCtrl],
                locals: {
                    "data": data,
                    "parentScope": $scope,
                    authService : authService,
                    localStorageService : localStorageService,
                    isFomArchive : isFomArchive
                },
                template: templatePop,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true
            })
        }
        $scope.onTabSelected = (data) => {
        }
        $scope.reset = (isArchivedTab = false) => {
            $scope.rc_selection = {
                all_selected : false,
                txt : _SELECTALL_TXT,
                selected_any : false
            }
            if(isArchivedTab){
                _.each(self.archived_templates, function(one){
                    one.to_archive = false
                })
            }else{
                _.each(self.availableFormats, function(one){
                    one.to_archive = false
                })
            }
        }
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Report Card Formats"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            loadFirst();
            pushLog();
        }
        this.$onDestroy = () => {
            if (subsReport)
                subsReport.stop()

            self.sessionArray = undefined
            self.curriculumArray = undefined
            self.classArray = undefined
            self.templated_based_academic = undefined
            self.availableFormats = undefined
            self.assigned_templates = undefined
        }

        function loadFirst() {
          $scope.isLoading = true  
          $scope.filterObj.academic_year = localStorageService.get('academic_year')  
          authService.callAPI("/v0/reportcards/manager/init", "POST", 
            {args : $scope.filterObj}, function (response) {
                let result = response.result.data.details.response
                console.log(result)
                if(result){
                    self.availableFormats = result.templates
                    self.archived_templates = result.archived_templates
                    iterateArray(self.availableFormats)
                    self.sessionArray = result.session
                    self.assigned_templates = result.assigned_templates ? result.assigned_templates : []
                    self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : []
                    for (let i = 0; i < self.templated_based_academic.length; i++) {
                        let classes = _.pluck(self.templated_based_academic[i].academics, "classes")
                        classes = _.flatten(classes)

                        if (!classes.length) {
                            self.templated_based_academic.splice(i, 1)
                        } else {}
                    }
                    if (result.schoolDoc) {
                        $scope.school_name = result.schoolDoc.school_name
                        $scope.schoolSelected = result.schoolDoc
                    }
                    if (result.schoolAdmin) {
                        $scope.schoolAdmin = result.schoolAdmin
                    }
                    $scope.formats_pending = result.formats_pending ? result.formats_pending : []
                }
                _.defer(function() {
                    $scope.isLoading = false
                    $scope.$apply();
                });;
          })
        }

        function removeTemplateWithNoClasses(templated_based_academic) {
            _.each(templated_based_academic, function(oneTemplate, key) {

            })
            for (let i = 0; i < templated_based_academic.length; i++) {
                let classes = _.pluck(templated_based_academic[i].academics, "classes")
                classes = _.flatten(classes)

                if (!classes.length) {
                    templated_based_academic.splice(i, 1)
                } else {
                }
            }
        }

        function clearFilter() {
            $scope.filterObj['session'] = undefined
            $scope.filterObj['curriculum'] = undefined
            $scope.filterObj['xclass'] = undefined
            $scope.filterObj['templates'] = undefined
        }
        
        $scope.searchValuesBasedOnFilter = function(ev) {
            if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
                toastr.error('Please Select the Session')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
                toastr.error('Please Select the Curriculum')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
                toastr.error('Please Select the Class')
                return false;
            } else if (this.filterObj === undefined || this.filterObj['templates'] === undefined || this.filterObj['templates'].length <= 0) {
                toastr.error('No report cards selected')
                return false;
            }
            this.filterObj['school_id'] = localStorageService.get('school_id')
            let showValidation = validate(this.filterObj)
            if(showValidation){
                showAssingWarning(this.filterObj, ev)
            }else{
                assignTemplate(this.filterObj)
            }
            // 
        }
        function showAssingWarning(filterObj, ev){
            var confirm = $mdDialog.confirm()
                  .title('Information')
                  .textContent('Some of the selected class(s) have been already assigned, but this will not cause any issues')
                  .ariaLabel('Lucky day')
                  .targetEvent(ev)
                  .ok('Proceed')
                  .cancel('Cancel');
                $mdDialog.show(confirm).then(function () {
                    assignTemplate(filterObj)
                }, function () {
            });;
        }
        function validate(filterObj){
            console.log(filterObj)
            let templates = filterObj['templates']
            let avails = self.availableFormats
            let session_id = filterObj.session
            let curr_id = filterObj.curriculum
            let xclass = filterObj.xclass
            let show_val = false
            try{
                for (let t = 0; t < templates.length; t++) {
                    let element = templates[t];
                    let rcs_selected = _.find(avails, function(one){
                        return one._id == element
                    })
                    if(rcs_selected){
                        let combExs = _.find(rcs_selected.assigned_academics, function(one){
                            return one.session_id == session_id && 
                            one.curriculum_id == curr_id
                        })
                        if(combExs && combExs.classes && combExs.classes.length){
                            for (let c = 0; c < xclass.length; c++) {
                                let selectedOneClass = xclass[c];
                                let classExs = _.find(combExs.classes, function(cls){
                                    return cls._id == selectedOneClass
                                })
                                if(classExs){
                                    show_val = true;
                                    break;
                                }
                            }
                        }
                    }
                }
            }catch(e){
                console.log(e)
                show_val = false
            }
            console.log(show_val)
            return show_val
        }
        function findAcadamicDetails(id) {
            let settings = Settings.findOne({
                type: "class",
                "list._id": id
            })
            if (settings) {
                let findClassObj = _.find(settings.list, function(list) {
                    return list._id == id
                })
                if (findClassObj) {
                    return findClassObj.name
                }
            }

        }

        function uploadToPmsFileServerAndSend(objdata, callBackData) {
            this.serverUrl = PMS_FILESERVER_URL + "/server-uploads"
            this.userPath = "pdfrequest/"
                // console.log($scope.dataArry.attachedFile)
                // return false


            uploadService.uploadToPMS($scope.dataArry.attachedFile, this.serverUrl, this.userPath, function(result) {
                if (result.url) {
                    console.log('pms')
                    console.log(result.url)
                    let objdata = {
                        "school_admin_id": Meteor.userId(),
                        "school_admin_email": $scope.schoolAdmin.username,
                        "school_id": $scope.schoolSelected._id,
                        "school_name": $scope.schoolSelected.school_name,
                        "details": $scope.dataArry.description,
                        "file_url": result.url
                    }
                    $scope.dataArry = undefined
                    Meteor.call('saveReportCardRequestToPMS', objdata, callBackData, function(err, res) {
                        if (err) {
                            toastr.error('Error on sending report card request')
                            return false
                        } else {
                            toastr.success('Report card request send successfully to the customer PMS')
                            $scope.formats_pending = res.formats_pending ? res.formats_pending : []
                        }
                        $scope.dataArry = undefined
                        _.defer(function() {
                            $scope.$apply();
                        });
                    })
                }
            })

        }
        $scope.sendRequest = function() {
            if ($scope.dataArry === undefined || $scope.dataArry.description === undefined || $scope.dataArry.description === '') {
                $scope.errors_description = "Description is required !";
                return false;
            } else {
                $scope.errors_description = undefined
                $scope.dataArry.date_added = new Date();
                // $scope.dataArry.school_id = $scope.schoolId;
                //$scope.dataArry.users = self.selectedDetails;
                $scope.dataArry.send_by = Meteor.userId() //logined user
                    //$scope.dataArry.send_to = roleType; // lower roles id
                    // console.log($scope.dataArry.attachedFile)
                if ($scope.dataArry.attachedFile) {
                    this.serverUrl = FILE_UPLOAD_URL + "/server-uploads"
                    this.userPath = "pdfrequest/"
                    uploadService.uploadCheckService($scope.dataArry.attachedFile, this.serverUrl, this.userPath, function(result) {
                        if (result.url) {
                            console.log(result.url)
                            let objdata = {
                                "school_admin_id": Meteor.userId(),
                                "school_admin_email": $scope.schoolAdmin.username,
                                "school_id": $scope.schoolSelected._id,
                                "school_name": $scope.schoolSelected.name,
                                "details": $scope.dataArry.description,
                                "file_url": result.url
                            }
                            uploadToPmsFileServerAndSend(objdata, result)

                        }
                    })
                } else {

                }
            }
        }

        function showValidationBforeAssign(filterObj, templated_based_academic) {
            if (filterObj.templates && filterObj.templates.length) {
                let rcFormats = ReportTemplatePreview.find({
                    _id: {
                        $in: filterObj.templates
                    }
                }).fetch()
                let templateSelectedArray = []
                _.each(filterObj.templates, function(rcFormat) {
                    let obj = {
                        format_id: rcFormat
                    }
                    let findFormat = _.find(rcFormats, function(eachDoc) {
                        return eachDoc._id == rcFormat
                    })
                    if (findFormat) {
                        obj['report_console_id'] = findFormat.report_console_id
                        obj['format_name'] = findFormat.name
                    }
                    templateSelectedArray.push(obj)
                })
                let validationArray = []
                _.each(templateSelectedArray, function(oneSelected) {
                    let obj = {}
                    obj['format_name'] = oneSelected.format_name

                    obj['classes_exists'] = []
                    let findAssigned = _.find(templated_based_academic, function(one) {

                        return one.report_console_id == oneSelected.report_console_id
                    })
                    if (findAssigned) {
                        let findFiltered = _.find(findAssigned.academics, function(academic) {
                                return academic.session_id == filterObj.session && academic.curriculum_id == filterObj.curriculum
                            })
                        obj['session'] = findFiltered.session
                        obj['curriculum'] = findFiltered.curriculum
                        if (findFiltered) {
                            if (filterObj.xclass) {
                                _.each(filterObj.xclass, function(oneSeltdClass) {
                                    let classIds = _.pluck(findFiltered.classes, "_id")
                                    if (classIds.indexOf(oneSeltdClass) !== -1) {
                                        let value = findAcadamicDetails(oneSeltdClass);
                                        if (!value) {
                                            value = oneSeltdClass
                                        }
                                        obj['classes_exists'].push(value)
                                    }
                                })
                            }
                        }
                    }

                })
            }
        }

        function assignTemplate(filterObj) {
            $scope.isLoading = true
                // showValidationBforeAssign(filterObj, self.templated_based_academic)
                // return false
            authService.callAPI("/v0/reportcards/manager/assign", "POST", 
            {args : {
                clientData : filterObj
            }}, function (response) {
                let result = response.result.data.details.response
                if (result) {
                    self.assigned_templates = []
                    self.assigned_templates = result.assigned_templates ? result.assigned_templates : []
                    self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : []
                    self.availableFormats = result.templates ? result.templates : []
                    iterateArray(self.availableFormats)
                }
                $scope.isLoading = false
                clearFilter()
                toastr.success('Assigned the template')
                _.defer(function() {
                    $scope.$apply();
                    self.selected_tab = 0
                });
                
            })
        }

        $scope.deleteClassFromTheTemplate = (template, academic, class_id) => {
            let params = {
                clientDataObj : {
                    report_console_id: template.report_console_id,
                    academics: {
                        session_id: academic.session_id,
                        curriculum_id: academic.curriculum_id,
                        school_id: $scope.filterObj['school_id'],
                        class_id: class_id,
                        report_console_id : template.report_console_id
                    }
                }
            }
            $scope.loading = true
                // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Would you like to delete permanently?')
                .textContent('Deleting will make data loss.Please make sure that reportcard is not generated using this template for this class')
                .ariaLabel('Lucky day')
                .ok('Delete')
                .cancel('Dont delete');

            $mdDialog.show(confirm).then(function() {
                authService.callAPI("/v0/reportcards/manager/deleteclass", "POST", 
                {args : params}, function (response) {
                    let result = response.result.data.details.response
                    if (result) {

                        self.templated_based_academic = []
                        self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : []
                            // removeTemplateWithNoClasses(self.templated_based_academic)
                        for (let i = 0; i < self.templated_based_academic.length; i++) {
                            let classes = _.pluck(self.templated_based_academic[i].academics, "classes")
                            classes = _.flatten(classes)

                            if (!classes.length) {
                                self.templated_based_academic.splice(i, 1)
                            } else {}
                        }
                    }
                    $scope.loading = false
                    toastr.success('Deleted')

                    _.defer(function() {
                        $scope.$apply();
                    });
                })
                // Meteor.call('deleteClassFromTemplate', params, function(error, result) {
                //     if (result) {

                //         self.templated_based_academic = []
                //         self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : []
                //             // removeTemplateWithNoClasses(self.templated_based_academic)
                //         for (let i = 0; i < self.templated_based_academic.length; i++) {
                //             let classes = _.pluck(self.templated_based_academic[i].academics, "classes")
                //             classes = _.flatten(classes)

                //             if (!classes.length) {
                //                 self.templated_based_academic.splice(i, 1)
                //             } else {}
                //         }
                //     }
                //     $scope.loading = false
                //     toastr.success('Deleted')

                //     _.defer(function() {
                //         $scope.$apply();
                //     });
                // })


            }, function(f, r) {
                $scope.loading = false
            });
            clearFilter();
        }
        $scope.setSessionFilters = (filterObj) => {
            if (!$scope.filterObj) {
                $scope.filterObj = {}
            }
            if ($scope.filterObj.curriculum) {
                delete $scope.filterObj.curriculum
            }
            if ($scope.filterObj.templates) {
                delete $scope.filterObj.templates
            }
            if ($scope.filterObj.xclass) {
                delete $scope.filterObj.xclass
            }
            // $scope.filterObj['school_id'] = Session.get('school_id')
            $scope.loading = true
            authService.callAPI("/v0/reportcards/manager/selectacademic", "POST", 
            {args : {
                filter : $scope.filterObj
            }}, function (response) {
                let result = response.result.data.details.response
                if (result) {
                    self.curriculumArray = []
                    self.curriculumArray = result.curriculum ? result.curriculum : []

                }
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        self.getClass = (filterObj) => {
            $scope.loading = true
            $scope.filterObj['curriculum'] = filterObj
            authService.callAPI("/v0/reportcards/manager/selectacademic", "POST", 
            {args : {
                filter : $scope.filterObj
            }}, function (response) {
                let result = response.result.data.details.response
                if (result) {
                    self.classArray = result.class

                }
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
            // Meteor.call('makeFilteredSeletction', $scope.filterObj, function(error, result) {
            //     if (result) {
            //         self.classArray = result.class
            //     }
            //     $scope.loading = false
            //     _.defer(function() {
            //         $scope.$apply();
            //     });
            // })
        }
        // self.deleteAssigned = (data, obj) => {
        //     $scope.loading = true

        //     // Appending dialog to document.body to cover sidenav in docs app
        //     var confirm = $mdDialog.confirm()
        //         .title('Would you like to delete permanently?')
        //         .textContent('Deleting will make data loss.Please make sure that reportcard is not generated using this template')
        //         .ariaLabel('Lucky day')
        //         .ok('Delete')
        //         .cancel('Dont delete');

        //     $mdDialog.show(confirm).then(function() {
        //         Meteor.call('deleteSelectedAcademic', data, obj, function(error, result) {
        //             if (result) {
        //                 self.assigned_templates = []
        //                 self.assigned_templates = result.assigned_templates ? result.assigned_templates : []
        //             }
        //             $scope.loading = false
        //             toastr.success('Deleted permanently')
        //             _.defer(function() {
        //                 $scope.$apply();
        //             });
        //         })


        //     }, function(f, r) {
        //         $scope.loading = false
        //     });

        // }
        $scope.showPdf = function(dataId, flag, format) {
            if (dataId) {
                // Meteor.call('getUploadedTEmplateById', dataId, flag, function(err, res) {
                //     if (res) {
                //         $scope.pdfData = true
                //         if (!flag) {
                //             res.path = FILE_UPLOAD_URL + res.path
                //         } else {
                //             res.path = FILE_UPLOAD_URL + res.file_url
                //         }

                //         res.path = $sce.trustAsResourceUrl(res.path)
                //         $scope.item = res
                //         _.defer(function() {
                //             $scope.$apply();
                //         });
                //     }
                // })
            }
        }
        $scope.backToHtml = () => {
            $scope.pdfData = false;
        }
        $scope.setProperty = (data) => {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'data', 'parentScope', 'sessionArray',
                 'school_id', 'authService', propertyController],
                locals: {
                    "data": data,
                    "parentScope": $scope,
                    sessionArray : self.sessionArray,
                    school_id : localStorageService.get('school_id'),
                    authService : authService
                },
                template: templateProperty,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true
            })
        }
        function pushLog(){ 
            let userIds = localStorageService.get('user_id');
            let schoolIds = localStorageService.get('school_id');
            authService.callRabbitMQAPI("/v0/rabbitmqpush/"+userIds+"/"+schoolIds+"/AssignReportFormat_View", "GET", {},function (response) {
                  // console.log(response)
            });
        }
    }

}
class propertyController {
    constructor($scope, $mdDialog, data, parentScope, sessionArray, school_id, authService) {
        
        let activeAcd = localStorage.getItem('academic_year')
        $scope.propertObj = {}
        $scope.array = [{name:1},{name:1},{name:1}]
        $scope.propertObj['school_id'] = school_id
        $scope.propertObj['activeAcd'] = activeAcd
        $scope.sessionArray = _.uniq(data.academics, false, function(one){
            return one.session_id
        })
        let curriculumToRemove = _.flatten(_.pluck(data.academics, 'curriculum_id'))
        $scope.getCurriculum = (id) => {
            /*get curriculum*/
            $scope.propertObj['class_id'] = undefined
            $scope.propertObj['batches'] = undefined
            $scope.propertObj['curriculum_id'] = undefined
            $scope.curriculumArray = []
            $scope.classArray = []
            $scope.batchesArray = []
            $scope.propertObj['session_id'] = id
            authService.callAPI("/v0/reportcards/manager/propertycurriculum", "POST", 
            {args : {
                propertObj : $scope.propertObj
            }}, function (response) {
                let result = response.result.data.details.response
                $scope.curriculumArray = result
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        $scope.getClassRc = (id) => {
            /*get curriculum*/
            $scope.propertObj['class_id'] = undefined
            $scope.propertObj['curriculum_id'] = id
            $scope.classArray = []
            $scope.batchesArray = []
            authService.callAPI("/v0/reportcards/manager/propertyclass", "POST", 
            {args : {
                propertObj : $scope.propertObj
            }}, function (response) {
                let result = response.result.data.details.response
                $scope.classArray = result
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        $scope.getBatchesRc = (id) => {
            /*get curriculum*/
            $scope.propertObj['class_id'] = id
            $scope.batchesArray = []
            authService.callAPI("/v0/reportcards/manager/propertybatch", "POST", 
            {args : {
                propertObj : $scope.propertObj
            }}, function (response) {
                let result = response.result.data.details.response
                $scope.batchesArray = result
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        function fetchSubjects(propertObj){
            $scope.loading = true
            authService.callAPI("/v0/reportcards/manager/propertysubject", "POST", 
            {args : {
                propertObj : $scope.propertObj
            }}, function (response) {
                
                let result = response.result.data.details.response
                console.log(result)
                $scope.subjectArray = result.subjectList
                $scope.subectArray = result.allSubjects
                $scope.loading = false
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        function validate(propertObj){
            if(!propertObj.session_id){
                toastr.error("Please select session!")
                return false
            }
            if(!propertObj.curriculum_id){
                toastr.error("Please select curriculum!")
                return false
            }
            if(!propertObj.class_id){
                toastr.error("Please select class!")
                return false
            }
            if(!propertObj.batches){
                toastr.error("Please select any batch!")
                return false
            }
            fetchSubjects(propertObj)
        }
        $scope.searchSubjects = () => {
            validate($scope.propertObj)
        }
        function validateProperty(list){
            let totalerror = 0
            _.each(list, function(oneObj){
                oneObj.errors = {}
                oneObj.use_in_report = true
                if(oneObj.is_linked){
                    if(!oneObj.linked_primary_subject){
                        oneObj.errors['linked_primary_subject'] = "Please select Primary subject"
                        totalerror++
                    }
                }
            })
            if(!totalerror){
                sendToServer(list)
            }
        }
        function sendToServer(list){
            list, school_id
            authService.callAPI("/v0/reportcards/manager/propertysave", "POST", 
            {args : {
                list : list,
                school_id : school_id
            }}, function (response) {
                let result = response.result.data.details.response
                if(result){
                    toastr.success("saved properties to the subjects")
                }
                $mdDialog.hide()
            })
        }
        $scope.saveSbjectProperty = () => {
            validateProperty($scope.subjectArray)
        }
        $scope.cancel = () => {
            $mdDialog.hide()
        }
        $scope.eventOfIslinked = (subject, index) => {
            let subjectPrimaryId = subject.linked_primary_subject
            if(subject.is_linked){
                _.each($scope.subectArray, function(eachColumn){
                    if(eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id){
                        if(subjectPrimaryId == eachColumn._id){
                            eachColumn.disableThis = true
                        }else{
                            eachColumn.disableThis = false
                        }
                    }
                })
            }else{
                if(subjectPrimaryId){
                    _.each($scope.subectArray, function(eachColumn){
                        if(eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id){
                            if(subjectPrimaryId == eachColumn._id){
                                eachColumn.disableThis = false
                            }
                        }
                    })
                }
            }
        }
        $scope.disableThisSubjectsPrimary = (subject) => {
            let subjectPrimaryId = subject.linked_primary_subject
            _.each($scope.subectArray, function(eachColumn){
                if(eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id){
                    if(subjectPrimaryId == eachColumn._id){
                       
                        if(subject.is_linked){
                            eachColumn.disableThis = true
                            eachColumn.is_linked = undefined
                            eachColumn.linked_primary_subject = undefined
                        }else{
                            eachColumn.disableThis = false
                        }
                        
                    }else{
                        eachColumn.disableThis = false
                    }
                }else{
                    // eachColumn.disableThis = false
                }
            })
            // _.each(self.addedSubjects, function(eachColumn){
            //     if(eachColumn._id == subjectId){
            //         eachColumn.disableThis = true
            //         eachColumn.is_linked = undefined
            //         eachColumn.linked_primary_subject = undefined
            //     }else{
            //         eachColumn.disableThis = false
            //     }
            // })
        }
    }
}

export default ManagelistController;
class ToArchiveCtrl {
    constructor($scope, $mdDialog, data, parentScope, authService,
        localStorageService, isFomArchive) {
        $scope.data = []
        $scope.parentScope = null
        let school_id = localStorageService.get('school_id')
        let _warning = "Warning : Selected report(s) will not be available to generate reports";
        let _heading = "Are you sure to archive?"
        let _btnTxt = "Move to Archive"
        if(isFomArchive){
            _warning = ""
            _heading = "Are you sure to restore?"
            _btnTxt = "Restore"
        }
        $scope.headers = {
            _heading : _heading,
            _warning : _warning,
            _btnTxt : _btnTxt,
            _disableBtn : false
        }
        this.$onInit = () => {
            $scope.data = data
            $scope.parentScope = parentScope
        }
        $scope.items = data
        
        $scope.cancel = () => {
            $mdDialog.hide()
        }
        $scope.confirm = () => {
            $scope.headers._disableBtn = true
            callArchivingApi()
        }
        function callArchivingApi(){
            let req = {
                user_id : localStorageService.get('user_id'),
                academic_year : localStorageService.get('academic_year'),
                items : data,
                school_id : school_id,
                restore : isFomArchive ? true : false
            }
            parentScope.isLoading = true
            $scope.cancel()
            let successTxt = isFomArchive ? "Restored selected report(s)" : "Archived the selected report(s)"
            authService.callAPI("/v0/reportcards/manager/archive/console", "POST", 
            req, function (response) {
                parentScope.isLoading = false
                $scope.headers._disableBtn = false
                let result = response.result.data.details.response
                if(result){
                    toastr.success(successTxt)
                    parentScope.callBack(result, isFomArchive)
                    
                }else{
                    toastr.success("Something went wrong")
                }
                
                // _.defer(function() {
                //     $scope.$apply();
                // });
            })
        }
    }
}
class OneRcController {
    constructor($scope, $mdDialog, data, format, parentScope, authService, localStorageService, cb, index) {
        let school_id = localStorageService.get('school_id')
        $scope.format = null
        let actual_format = null
        $scope.real_format = null
        let _SELECTALL_TXT = "Select All"
        let _UNSELECTALL_TXT = "Unselect All"
        $scope.isLoading = false
        $scope.updatorData = {
            update : false
        }
        $scope.class_removal = {
            confirm : false
        }
        $scope.display_name_length = 20
        $scope.name_length = 40
        function _breakReference(data) {
            let keys = Object.keys(data)
            let obj = {}
            for (let k = 0; k < keys.length; k++) {
                obj[keys[k]] = data[keys[k]]
            }
            return obj
        }
        $scope.saveMetadata = () => {
            $scope.updatorData.update = true
        }
        $scope.cancelUpdate = () => {
            $scope.updatorData.update = false
        }
        function validateCode(string) {
            let TCode = string
            for (let i = 0; i < TCode.length; i++) {
                let char1 = TCode.charAt(i);
                let cc = char1.charCodeAt(0);
                if ((cc > 47 && cc < 58) || (cc > 64 && cc < 91) || (cc > 96 && cc < 123)) {
                } else {
                    return false;
                }
            }
            return true;
        }
        $scope.doUpdate = () => {
            
            let _format = $scope.format
            _format.error = {}
            let err = 0
            if(_format){
                if(!_format.name){
                    _format.error['name'] = {}
                    _format.error['name']['msg'] = "Name is required"
                    err++
                }
                if(_format.name){
                    let trimmed = _format.name.trim()
                    let len = trimmed.length
                    if(len > $scope.name_length){
                        _format.error['name'] = {}
                        _format.error['name']['msg'] = "Report name should not exceed " + $scope.name_length 
                        err++
                    }
                }
                if(_format.display_name){
                    let trimmed = _format.display_name.trim()
                    let len = trimmed.length
                    if(len > $scope.display_name_length){
                        _format.error['display_name'] = {}
                        _format.error['display_name']['msg'] = "Display name should not exceed " + $scope.display_name_length 
                        err++
                    }
                }
            }
            if(err){
                return false
            }
            $scope.isLoading = true
            let req = {
                user_id : localStorageService.get('user_id'),
                academic_year : localStorageService.get('academic_year'),
                _id : _format.report_console_id,
                school_id : school_id,
                format : _format
            }
            authService.callAPI("/v0/reportcards/manager/update/metadata", "POST", 
            req, function (response) {
                
                $scope.isLoading = false
                $scope.cancelUpdate()
                let result = response.result.data.details.response
                if(result){
                    toastr.success("Updated successfully")
                }else{
                    toastr.success("Something went wrong")
                }
                cb(format, index)
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
        
        this.$onInit = () => {
            $scope.real_format = format
            let actual_format = format
            format = _breakReference(format)
            format.can_delete_classes = false
            if(format.assigned_academics &&
                 format.assigned_academics.length){
                let assigned_academics = format.assigned_academics
                for (let e = 0; e < assigned_academics.length; e++) {
                    let acd = assigned_academics[e]
                    // let xclasses = []
                    // if(acd && acd.classes && acd.classes.length){
                    //     _.each(acd.classes, function(one){
                    //         one.to_remove = false
                    //         xclasses.push(_breakReference(one))
                    //     })
                    // }
                    // acd.classes = xclasses
                    // console.log(acd)
                    assigned_academics[e] = acd
                }
            }
            $scope.format = format
        }
        function doBack(){
            let format = $scope.format 
            if(format && format.assigned_academics &&
                format.assigned_academics.length){
               let assigned_academics = format.assigned_academics
               for (let e = 0; e < assigned_academics.length; e++) {
                   let acd = assigned_academics[e];
                   // let xclasses = []
                   if(acd && acd.classes && acd.classes.length){
                       _.each(acd.classes, function(one){
                           one.to_remove = false
                       })
                   }
                   // acd.classes = xclasses
                   // console.log(acd)
                   assigned_academics[e] = acd
               }
           }
            $scope.format = null
            $scope.real_format = null
        }
        this.$onDestroy = () => {
            // doBack()
        }
        $scope.cancel = () => {
            doBack()
            $mdDialog.hide()
        }
        $scope.confirm = () => {
        }
        $scope.selectAllClassesPerReport = (format, event) => {
            let class_selection = format.class_selection
            if(class_selection){
                format.class_selection_txt = _UNSELECTALL_TXT
            }else{
                format.class_selection_txt = _SELECTALL_TXT
                $scope.class_removal.confirm = false
            }
            if(format.assigned_academics && format.assigned_academics.length){
                let assigned_academics = format.assigned_academics
                for (let e = 0; e < assigned_academics.length; e++) {
                    let element = assigned_academics[e];
                    if(element.classes && element.classes.length){
                        let classes = element.classes
                        for (let c = 0; c < classes.length; c++) {
                            classes[c].to_remove = class_selection
                        }
                    }
                }
            }
            showHideClassRemoveBtn(format)
        }
        $scope.oneClassSelection = (format, selectedclass) => {
            let to_remove = selectedclass.to_remove
            if(!to_remove){
                format.class_selection_txt = _SELECTALL_TXT
                format.class_selection = false
            }
            showHideClassRemoveBtn(format)
        }
        function showHideClassRemoveBtn(format){
            format.can_delete_classes = false
            if(format.assigned_academics && format.assigned_academics.length){
                let assigned_academics = format.assigned_academics
                for (let e = 0; e < assigned_academics.length; e++) {
                    let element = assigned_academics[e];
                    if(element.classes && element.classes.length){
                        let classes = element.classes
                        for (let c = 0; c < classes.length; c++) {
                            if(classes[c].to_remove){
                                format.can_delete_classes = true
                                $scope.class_removal.confirm = false
                                break;
                            }
                        }
                    }
                }
            }
        }
        $scope.cancelClassRemovaval = (format) => {
            $scope.class_removal.confirm = false
            showHideClassRemoveBtn(format)
        }
        $scope.deleteClassFromTheTemplate = (template, academic, class_id) => {
            if(academic.classes){
                for (let index = 0; index < academic.classes.length; index++) {
                    let element = academic.classes[index];
                    if(element && element._id == class_id){
                        academic.classes.splice(index, 1)
                        break;
                    }
                }
            }
            parentScope.deleteClassFromTheTemplate(template, academic, class_id)
        }
        $scope.removeClasses = (format) => {
            let remove_params = []
            if(format.assigned_academics && format.assigned_academics.length){
                let assigned_academics = format.assigned_academics
                for (let e = 0; e < assigned_academics.length; e++) {
                    let element = assigned_academics[e];
                    let obj = {
                        session_id : element.session_id,
                        curriculum_id : element.curriculum_id,
                        classes : []
                    }
                    if(element.classes && element.classes.length){
                        let classes = element.classes
                        for (let c = 0; c < classes.length; c++) {
                            if(classes[c].to_remove){
                                obj.classes.push(classes[c]._id);
                            }
                        }
                    }
                    if(obj.classes.length){
                        remove_params.push(obj)
                    }
                }
            }
            if(remove_params.length){
                removeClassCallApi(remove_params, format)
            }
        }
        function removeClassessFromClient(formatP){
            let total_classes = 0
            if(formatP.assigned_academics && formatP.assigned_academics.length){
                let assigned_academics = formatP.assigned_academics
                for (let e = 0; e < assigned_academics.length; e++) {
                    let element = assigned_academics[e];
                    if(element.classes && element.classes.length){
                        let classes = element.classes
                        let con = 0
                        let exs = _.filter(element.classes, function (one){
                            return one.to_remove != true
                        })
                        element.classes = exs
                        total_classes = total_classes + exs.length
                        // for (let c = 0; c < classes.length; c++) {
                        //     if(classes[c].to_remove){
                        //         classes.splice(c, 1)
                        //         con++
                        //     }
                        // }
                    }
                    
                }
            }
            formatP.total_classes = total_classes
            if(total_classes){
                formatP.isassigned = true
            }else{
                formatP.isassigned = false
            }
            formatP.can_delete_classes = false
            $scope.class_removal.confirm = false
            formatP.class_selection_txt = _SELECTALL_TXT
            formatP.class_selection = false
            cb(formatP, index)
        }
        function removeClassCallApi(remove_params, formatP){
            let req = {
                user_id : localStorageService.get('user_id'),
                academic_year : localStorageService.get('academic_year'),
                _id : formatP.report_console_id,
                school_id : school_id,
                academics : remove_params
            }
            $scope.isLoading = true
            authService.callAPI("/v0/reportcards/manager/removeclasses", "POST", 
            req, function (response) {
                $scope.isLoading = false
                let result = response.result.data.details.response
                if(result){
                    console.log(formatP)
                    removeClassessFromClient(formatP)
                    toastr.success("Removed selected classes")
                }
                _.defer(function() {
                    $scope.$apply();
                });
            })
        }
    }
}
class showPdfDialog {
    constructor($scope, $mdDialog, format, parentScope, authService,
        localStorageService, isFomArchive, $sce) {
        $scope.format = null
        this.$onInit = () => {
            if(format){
                format.url = $sce.trustAsResourceUrl(format.path)
                $scope.format = format
            }
        }
        $scope.cancel = () => {
            $mdDialog.hide()
        }
      
    }
}


// WEBPACK FOOTER //
// ./src/app/report_cards/manage_reports/controllers/managelistController.js